// Statične konstante aplikacije E-Turizam

export const CITIES = [
  'Travnik', 'Novi Travnik', 'Vitez', 'Busovača', 'Bugojno', 'Donji Vakuf',
  'Gornji Vakuf-Uskoplje', 'Jajce', 'Dobretići', 'Fojnica', 'Kiseljak', 'Kreševo'
];

export const IMG = {
  jajceFall: 'https://images.unsplash.com/photo-1721240670951-992bd43f73ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  fortress: 'https://images.unsplash.com/photo-1711039406546-bdaa5fd12d1b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  fortress2: 'https://images.unsplash.com/photo-1698151911188-dd91b1477444?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  lake1: 'https://images.unsplash.com/photo-1603979649806-5299879db16b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  lake2: 'https://images.unsplash.com/photo-1594175268654-e60bea6c037c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  lake3: 'https://images.unsplash.com/photo-1516655855035-d5215bcb5604?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  oldtown1: 'https://images.unsplash.com/photo-1605096048662-5ab61695a122?q=85&w=1200&fm=jpg',
  oldtown2: 'https://images.unsplash.com/photo-1517606261660-fd72f84596b3?q=85&w=1200&fm=jpg',
  oldtown3: 'https://images.unsplash.com/photo-1578771792482-1e7eb2b8b447?q=85&w=1200&fm=jpg',
  ski1: 'https://images.unsplash.com/photo-1519659675643-e5885721661f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  ski2: 'https://images.unsplash.com/photo-1550503736-c1a2c9033c03?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  food1: 'https://images.unsplash.com/photo-1613653739328-e86ebd77c9c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  food2: 'https://images.unsplash.com/photo-1593252719532-53f183016149?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  hotel1: 'https://images.unsplash.com/photo-1615676893771-94c4d0a2f1ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  hotel2: 'https://images.unsplash.com/photo-1445019980597-93fa8acb246c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  hotel3: 'https://images.unsplash.com/photo-1615880484746-a134be9a6ecf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200'
};

export const PERMISSIONS = [
  { key: 'manage_offers', label: 'Upravljanje turističkom ponudom' },
  { key: 'manage_events', label: 'Upravljanje događajima' },
  { key: 'manage_notices', label: 'Upravljanje obavijestima' },
  { key: 'manage_types', label: 'Upravljanje tipovima i kategorijama' },
  { key: 'manage_users', label: 'Upravljanje korisnicima' },
  { key: 'manage_roles', label: 'Upravljanje ulogama i dozvolama' },
  { key: 'approve_subjects', label: 'Odobravanje registracija subjekata' },
  { key: 'approve_events', label: 'Odobravanje događaja' },
  { key: 'view_reports', label: 'Pregled izvještaja (prijave/odjave)' },
  { key: 'manage_own_object', label: 'Upravljanje vlastitim objektom' }
];
